import { Component, OnInit } from '@angular/core';
import { UserData } from 'src/app/Models/Account/user-data';
import { AppStateService } from 'src/app/Services/AppState/app-state.service';
import { ModalCreateUserComponent } from '../modal-create-user/modal-create-user.component';
import { PasswordChangedComponent } from '../password-changed/password-changed.component';
import { UserInfoComponent } from '../user-info/user-info.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { ListPaginatorComponent } from '../list-paginator/list-paginator.component';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-administration-users',
  templateUrl: './administration-users.component.html',
  styleUrls: ['./administration-users.component.scss'],
  standalone: true,
  imports: [
    MatFormFieldModule
    , MatInputModule
    , MatTableModule
    , MatCheckboxModule
    , MatMenuModule
    , MatIconModule
    , ListPaginatorComponent
    , CommonModule
  ]
})
export class AdministrationUsersComponent implements OnInit {
  displayedColumns: string[] = ['nombre', 'correo', 'acceso', 'menu'];

  constructor(
    public appStateService: AppStateService
  ) {}

  ngOnInit(): void {
    this.appStateService.cleanPaginator();
    this.onActualizar();
  }

  onActualizar = () => this.appStateService.UserService.GetListUsers().subscribe();

  PasswordChangeAdmin({accountID}: UserData) {
    this.appStateService.dialog.open(PasswordChangedComponent, {
      maxWidth: '95%',
      maxHeight: '95%',
      width: '491px',
      data: { accountID },
    });
  }

  RemoveAllTwoFactorComponent(element: UserData) {
    this.appStateService.TwoFactorService.RemoveAllTwoFactor(element.accountID);
  }
  SetAllCompanyAccessAsyncComponent(element: UserData) {
    this.appStateService.SetAllCompanyAccessAsync(element.accountID);
  }

  ModifiedUser({accountID}: UserData) {
    this.appStateService.dialog.open(UserInfoComponent, {
      maxWidth: '95%',
      maxHeight: '95%',
      width: '491px',
      data: accountID,
    });
  }

  filter(event: KeyboardEvent) {
    const filterValue = (event.target as HTMLInputElement).value;
    if (filterValue.length >= 1 && event.key === 'Enter') {
      this.appStateService.folder.filter = filterValue;
      this.onActualizar();
    } else if (filterValue.length === 0 || filterValue === '') {
      this.appStateService.cleanPaginator();
      this.onActualizar();
    }
  }

  isDisabled = ({isAdmin, hasCompanyAccess, permissions}: UserData) => !compareTwoArray<boolean>([isAdmin, hasCompanyAccess], permissions);

  canManagP(element: UserData) {
    element.isAdmin = !element.isAdmin;
  }

  canAccesC(element: UserData) {
    element.hasCompanyAccess = !element.hasCompanyAccess;
  }
  onFormSubmit({accountID, isAdmin, hasCompanyAccess}: UserData) {
    this.appStateService.SetPermissionsByAdmin(
      accountID,
      isAdmin,
      hasCompanyAccess
    );
  }

  CreateUser() {
    this.appStateService.dialog.open(ModalCreateUserComponent, {
      maxWidth: '95%',
      maxHeight: '95%',
      width: '491px',
      id: '',
      data: '',
    });
  }
}

function compareTwoArray<T>(arr1: Array<T>, arr2: Array<T>){
  if(arr1?.length !== arr2?.length){
    return false;
  }
  return arr1.every((value, index) => value === arr2[index]);
}
